export default (): void => {
  const companiesElementId = 'recently-visited-companies'

  const toggleVisibilityOnSearch = (searchInput: { empty: boolean }): void => {
    const element = document.getElementById(companiesElementId)

    if (element === null) {
      return
    }

    window.requestAnimationFrame(() => {
      element.style.display = searchInput.empty ? 'block' : 'none'
    })
  }

  window.onDomLoad(function () {
    window.eventHub.$off('quickSearch:searchQueryUpdated')
    window.eventHub.$on(
      'quickSearch:searchQueryUpdated',
      toggleVisibilityOnSearch
    )
  })
}
